import { ChangeEvent, FC } from "react";
import { FloatingInputLocationProps } from "../../types";
import { Controller } from "react-hook-form";
import { pickup_icon } from "../../assets/images";
import "./styles.css";

const FloatingInputLocation: FC<FloatingInputLocationProps> = ({
  onInputChange,
  inputType,
  className,
  label,
  editable,
  placeholder,
  control,
  inputName,
  rules = {},
  selectedLocationName,
}) => {
  const handleOnChange = (input: string, onChange: any) => {
    onInputChange(input);
    onChange(input);
  };

  return (
    <Controller
      control={control}
      name={inputName}
      rules={rules}
      render={({
        field: { value, onChange, onBlur },
        fieldState: { error },
      }) => (
        <div
          className={` merchant-input-style-create-product form-floating-label text-start ${className} ${error ? "hasError" : ""
            }`}
        >
          <div className="d-flex align-items-center">
            <img src={pickup_icon} alt="Calendar Icon" className="me-2" />
            <div style={{ width: "100%" }}>
              <label
                htmlFor="floatingInput"
                className=""
              >
                {label}
              </label>

              <input
                id="floatingInput"
                type={inputType}
                className={`form-control floating-input-style ${className} ${error ? "hasError" : ""
                  }`}
                placeholder={placeholder}
                readOnly={!editable}
                autoComplete="off"
                value={selectedLocationName}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  handleOnChange(e.target.value, onChange)
                }
              />
            </div>

          </div>


          {error && (
            <div className="errorTextContainer">
              <div className="errorText">{error?.message || "Error"}</div>
            </div>
          )}
        </div>
      )}
    />
  );
};

export default FloatingInputLocation;
